<template>
  <v-container id="login" class="fill-height justify-center" tag="section">
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card
          color="secondary"
          light
          max-width="100%"
          width="400"
          class="px-5 py-3"
        >
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold mb-2">Reset Password</h1>
            </div>
          </template>

          <v-card-text class="text-center">
            <form v-on:submit="resetPassword" action="javascript:void(0);">
              <v-text-field
                color="secondary"
                v-model="email"
                label="Email..."
                readonly
                prepend-icon="mdi-email"
              />

              <v-text-field
                class="mb-8"
                color="secondary"
                label="Password..."
                type="password"
                v-model="password"
                prepend-icon="mdi-lock-outline"
              />

              <pages-btn
                large
                color
                depressed
                type="submit"
                class="v-btn--text success--text"
                >Let's Go</pages-btn
              >
            </form>
          </v-card-text>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
    <v-dialog v-model="dialog" max-width="500">
      <v-card class="text-center">
        <v-card-title>
          {{ dialog_title }}
          <v-spacer />

          <v-icon aria-label="Close" @click="dialog = false">mdi-close</v-icon>
        </v-card-title>

        <v-card-text>{{ dialog_text }}</v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn color="error" text @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Swal from "sweetalert2";
export default {
  data() {
    return {
      email: "",
      password: "",
      token: "",
      message: "",
      dialog: false,
      dialog_title: null,
      dialog_text: null,
    };
  },
  components: {
    PagesBtn: () => import("./components/Btn"),
  },
  created() {
    this._data.email = this.$route.params.email;
    this._data.token = this.$route.params.token;
  },
  methods: {
    resetPassword: function (event) {
      let _ = this;
      this.axios({
        method: "POST",
        url: "/public/portal/resetPassword",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          local: window.selectedLanguage,
        },
        data: {
          email: _._data.email,
          pwd: _._data.password,
          key: _._data.token,
        },
      }).then(function (json) {
        if (json.data.msg.severity > 0) {
          _._data.message = json.data.msg.msgTxt;
          _._data.dialog_title = "There was an error";
          _._data.dialog_text = json.data.msg.msgTxt;
          _._data.dialog = true;
        } else {
          Swal.fire({
            title: "Reset completed",
            html: json.data.msg.msgTxt,
          }).then(function (result) {
            _.setAuthToken(json.data.data.token);
          });
        }
      });
    },
  },
};
</script>

<style></style>
